const MeasurementStatus = {
	RECORDING: 'Recording submitted',
	WAITING_FOR_DATA: 'Waiting for Data',
	TRANSFERRING_DATA: 'Transferring Data',
	TRANSFER_ERROR: 'Transfer Error(Checksum)',
	DONE: 'Done',
	CSV_CONVERSION: 'CSV conversion',
	CSV_CONVERSION_FAILED: 'CSV conversion failed',
	NO_DATA: 'No Data'
};

export default MeasurementStatus;
